import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider as TeamsContextProvider } from 'components/Managers/Teams/Context';
import { ContextProvider as TemplatesContextProvider } from 'components/Managers/Templates/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index({ enterpriseId, policyEnabled }) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <TeamsContextProvider>
          <TemplatesContextProvider enterpriseId={enterpriseId}>
            <ContextProvider enterpriseId={enterpriseId} policyEnabled={policyEnabled}>
              <Main />
            </ContextProvider>
          </TemplatesContextProvider>
        </TeamsContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  policyEnabled: PropTypes.bool.isRequired,
};
